<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="title">3天CP·爱在进行时</div>
      <div class="declaration">
        人生海海<br>总会有一个人会成为你的信徒<br>穿越茫茫人海与你一见如故<br>
        陪你见证宇宙山河浪漫，人间点滴温暖<br>在这里，开启你的邂逅之旅吧
      </div> -->
      <img class="pic-title" src="https://static.huiyiji520.com/cppic-1661943120.png">
      <img class="pic-declaration" src="https://static.huiyiji520.com/cppic-1661823673.png">
      <div class="btn-me flex-box" @click="goNext()">立即报名</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'

export default{
  components: {
    [Dialog.name]: Dialog
  },
  data(){
    return {

    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goNext(){
      let searchParams = new URLSearchParams(window.location.search)
      let referal = searchParams.get("referal") ? searchParams.get("referal") : "matrix"
      // alert('goNext referal: ' + referal)
      this.handleRouter('/choose_me_sex?referal=' + referal)
    },
    checkCurrentIssue(){
      let searchParams = new URLSearchParams(window.location.search)
      let issue = searchParams.get("issue") ? searchParams.get("issue") : "matrix"
      if(issue != "twelve"){
        Dialog.confirm({
          message: '上期活动报名已结束，下期报名尚未开始，敬请期待！',
          showConfirmButton: false,
          showCancelButton: false
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
      }
    },
    closeEnroll(){
      Dialog.confirm({
        message: '活动报名已结束，下期报名尚未开始，敬请期待！',
        showConfirmButton: false,
        showCancelButton: false
      })
      .then(() => {
        // on confirm
      })
      .catch(() => {
        // on cancel
      });
    },
    checkeCurrentStage(){
      let searchParams = new URLSearchParams(window.location.search)
      let referal = searchParams.get("referal") ? searchParams.get("referal") : "matrix"
      let stage = this.$store.state.currentStage
      if(stage != "enrolling" && stage != "matching"){
        this.closeEnroll()
      }
    }
  },
  mounted(){
    this.checkeCurrentStage()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background-image: url("https://static.huiyiji520.com/cponline-1659166921.jpg"); */
  /* background-image: url("https://static.huiyiji520.com/bg-1661137902.png"); */
  background-image: url("https://static.huiyiji520.com/cppic-1661150074.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
/* .main .title{margin-top:200px;margin-bottom:113px;font-size:70px;color:#eb8e80;font-weight:bold;font-family:'NotoSerifSCBlack';}
.main .declaration{font-size:40px;line-height:80px;color:#737373;margin-bottom:113px;} */
.btn-me{
  width:342px;height:90px;font-size:40px;border:5px solid #f1b8af;border-radius:30px;
  margin:0px auto;color:#ffffff;background:#f1b8af;justify-content:center;
}
/* position:fixed;bottom:200px;left:0;right:0; */
.main .pic-title{width:202px;height:65px;margin:0 auto;margin-top:207px;margin-bottom:170px;}
.main .pic-declaration{width:704px;height:445px;margin:0 auto;margin-bottom:150px;}
</style>
